<template>
  <div class="form-reg-prod pa-2">
    <v-container fluid class="form-reg-prod-container pa-0">

      <v-row no-gutters class="text-left">
        <v-col cols="12" md="6" class="pe-md-3 pe-0 form-reg-prod-col">
          <v-row no-gutters class="flex-grow-0 flex-shrink-0">
            <v-col class="text-left">
              <h4 class="header-label">■検索</h4>
            </v-col>
          </v-row>
          <v-row no-gutters class="flex-grow-0 flex-shrink-0">
            <v-col cols="5" class="pe-2">
              <v-select v-model="selectedType" :options="types" option-text="label" option-value="value" label="label"
                placeholder="廃棄タイプ" @input="handleChangeTypeItem" :clearable="false" />
            </v-col>
            <v-col cols="7" class="ps-2">
              <v-autocomplete class="custom-autocomplete" :filter="customProductFilter" outlined dense clearable
                v-model="selectedItem" :items="items" :loading="isLoading1" hide-no-data append-icon="mdi-magnify"
                placeholder="廃棄品コード/名称"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-3 mb-6 flex-grow-0 flex-shrink-0">
            <v-col class="text-left">
              <v-btn class="font-weight-bold" style="min-width: 86px;" :large="$vuetify.breakpoint.mdAndUp"
                @click="handleSearchClick" color="success">
                検索
              </v-btn>
            </v-col>
          </v-row>

          <v-row no-gutters class="flex-grow-0 flex-shrink-0">
            <v-col class="text-left">
              <h4 class="header-label">■廃棄一覧</h4>
            </v-col>
          </v-row>

          <v-row no-gutters class="content-styled-table">
            <v-col>
              <div class="styled-table-wrapper">
                <table class="styled-table">
                  <thead>
                    <tr>
                      <th width="34%" class="text-center">名称</th>
                      <th width="30%" class="text-center">数量</th>
                      <th width="18%" class="text-center">単位</th>
                      <th width="18%" class="text-center">理由</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(disposal, index) in disposalsUpdate" :key="index">
                      <td class="text-left">{{ disposal.name }}</td>
                      <td>
                        <div class="full-size-div input-quantity no-spinner" :class="{ focus: disposal.isFocused }">
                          <button v-if="isToday(disposal.updated_at)" class="close-icon" @click="handleCloseClick(disposal)">×</button>
                          <input class="full-size-input no-spinner" v-model.number="disposal.disposal_quantity"
                            type="number" @input="removeLeadingZeros(disposal,'update')" @click="resetInput(disposal)" @focus="setFocus(disposal, true)" @blur="setFocus(disposal, false)" />
                        </div>
                      </td>
                      <td>
                        <div class="full-size-div">
                          <select class="full-size-input" v-model="disposal.disposal_unit_code" ref="select"
                            @change="(e) => handleChangeUnit(e, disposal)">
                            <option v-for="(unit, index) in getUnits(disposal)" :key="index" :value="unit.value">
                              {{ unit.name }}
                            </option>
                          </select>
                        </div>
                      </td>
                      <td>
                        <div class="full-size-div">
                          <select class="full-size-input" v-model="disposal.disposal_reason_code"
                            @change="(e) => handleChangeReason(e, disposal)">
                            <option v-for="(reason, index) in reasons" :key="index" :value="reason.value">
                              {{ reason.name }}
                            </option>
                          </select>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-3 mb-10 flex-grow-0 flex-shrink-0">
            <v-col class="text-left">
              <v-btn class="font-weight-bold" style="min-width: 86px;" @click="handleRegister"
                :large="$vuetify.breakpoint.mdAndUp" :disabled="stateDisableBtnUpdate" color="success">
                登録
              </v-btn>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="6" class="ps-md-3 ps-0 form-reg-prod-col">
          <v-row no-gutters class="flex-grow-0 flex-shrink-0">
            <v-col class="text-left">
              <h4 class="header-label">■臨時登録</h4>
            </v-col>
          </v-row>
          <v-row no-gutters class="flex-grow-0 flex-shrink-0">
            <v-col cols="5" class="pe-2">
              <v-select v-model="selectedType2" :options="types" option-text="label" option-value="value" label="label"
                placeholder="廃棄タイプ" @input="handleChangeTypeItem2" :clearable="false" />
            </v-col>
            <v-col cols="7" class="ps-2">
              <v-autocomplete class="custom-autocomplete" :filter="customProductFilter" outlined dense clearable
                v-model="selectedItem2" :loading="isLoading2" hide-no-data :items="items2" append-icon="mdi-magnify"
                placeholder="廃棄品コード/名称"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-3 mb-6 flex-grow-0 flex-shrink-0">
            <v-col class="text-left">
              <v-btn class="font-weight-bold" style="min-width: 86px;" :large="$vuetify.breakpoint.mdAndUp"
                @click="handleSearchRegister" color="success">
                検索
              </v-btn>
            </v-col>
          </v-row>

          <v-row no-gutters class="flex-grow-0 flex-shrink-0">
            <v-col class="text-left d-md-block d-none">
              <h4 class="header-label">&nbsp;</h4>
            </v-col>
          </v-row>

          <v-row no-gutters class="content-styled-table">
            <v-col>
              <div class="styled-table-wrapper">
                <table class="styled-table">
                  <thead>
                    <tr>
                      <th width="34%" class="text-center">名称</th>
                      <th width="30%" class="text-center">数量</th>
                      <th width="18%" class="text-center">単位</th>
                      <th width="18%" class="text-center">理由</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(disposal, index) in disposalsInsert" :key="index">
                      <td class="text-left">{{ disposal.name }}</td>
                      <td class="text-center">
                        <div class="full-size-div">
                          <input class="full-size-input input-quantity no-spinner"
                            v-model.number="disposal.disposal_quantity" type="number"
                            @input="removeLeadingZeros(disposal, 'insert')" @click="resetInput(disposal)" />
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="full-size-div">
                          <select class="full-size-input" v-model="disposal.disposal_unit_code" ref="select"
                            @change="(e) => handleChangeUnit2(e, disposal)">
                            <option v-for="(unit, index) in getUnits(disposal)" :key="index" :value="unit.value">
                              {{ unit.name }}
                            </option>
                          </select>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="full-size-div">
                          <select class="full-size-input" v-model="disposal.disposal_reason_code"
                            @change="(e) => handleChangeReason2(e, disposal)">
                            <option v-for="(reason, index) in reasons" :key="index" :value="reason.value">
                              {{ reason.name }}
                            </option>
                          </select>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-3 mb-10 flex-grow-0 flex-shrink-0">
            <v-col class="text-left">
              <v-btn class="font-weight-bold" style="min-width: 86px;" :large="$vuetify.breakpoint.mdAndUp"
                @click="handleInsert" :disabled="stateDisableBtnCreate" color="success">
                登録
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-row justify="center">
      <alert-dialog :dialog="dialog" @dialog-changed="handleDialogChange" title="成功"
        content="情報の保存に成功しました"></alert-dialog>
      <alert-dialog :dialog="dialogError" @dialog-changed="handleDialogChangeError" title="データエラー"
        content="廃棄金額が5000円を超えています。入力内容を確認してください"></alert-dialog>
      <alert-dialog :dialog="dialogErrorAmount" @dialog-changed="handleDialogChangeErrorAmount" title="データエラー"
        content="廃棄数量を入力してください"></alert-dialog>
      <alert-dialog :dialog="dialogErrorSubmitInsert" @dialog-changed="handleDialogChangeErrorSubmit" title="データエラー"
        content="既に登録されています。一覧から廃棄数量を入力してください"></alert-dialog>
      <alert-dialog :dialog="dialogErrorReason" @dialog-changed="handleDialogChangeErrorReason" title="データエラー"
        content="廃棄理由を選択してください"></alert-dialog>
      <alert-dialog :dialog="dialogErrorMaxLength" @dialog-changed="handleDialogErrorMaxLength" title="データエラー"
        content="数値は５桁までで入力してください"></alert-dialog>
      <alert-dialog :dialog="dialogErrorItemZero" @dialog-changed="handleDialogErrorItemZero" title="データエラー"
        content="廃棄登録の削除は‪✕‬ボタンから行って下さい"></alert-dialog>

      <confirm-dialog
      :title="dialogTitle"
      :content="dialogContent"
      :dialog="isConfirmDialogOpen"
      @dialog-changed="handleDialogChange"
      @confirm="handleConfirm"
      @cancel="handleCancelConfirm"
    />
    </v-row>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
import AlertDialog from './AlertDialog.vue';
import ConfirmDialog from "./ConfirmDialog.vue";
import { debounce } from 'lodash';
import { normalizeToKatakana } from '../utils';

export default {
  name: "RegistrationProduct",
  components: {
    vSelect,
    AlertDialog,
    ConfirmDialog
  },
  created() {
    axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
    this.getTypes();
    this.getReasons();
    this.getItems();
    this.getItems2();
    this.filterSearch();
    const filterRegister = this.$store.state.filterRegister;
    if (filterRegister) {
      this.filterSearchRegister();
    }
  },
  mounted() {
    // this.removeCache();
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    // this.checkReloadStatus();
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  data() {
    return {
      isLoading1: false,
      isLoading2: false,
      dialog: false,
      dialogError: false,
      dialogErrorAmount: false,
      dialogErrorSubmitInsert: false,
      dialogErrorReason: false,
      dialogErrorMaxLength: false,
      dialogErrorItemZero: false,
      types: [],
      selectedType: this.$store.state.type1,
      selectedType2: this.$store.state.type2,
      itemProducts: [],
      selectedReason: 1,
      reasons: [],
      selectedUnit: 1,
      units: [],
      selectedItem: this.$store.state.code1,
      items: [],
      selectedItem2: this.$store.state.code2,
      items2: [],
      disposals: [],
      disposalItemCode: null,
      disposalsUpdate: this.$store.state.dataUpdate,
      disposalsInsert: this.$store.state.dataInsert,
      stateDisableBtnUpdate: false,
      stateDisableBtnCreate: false,
      isConfirmDialogOpen: false,
      dialogTitle: '',
      dialogContent: '',
      itemDelete: null,
    };
  },
  methods: {
    isToday(date) {
      const today = new Date().toISOString().split('T')[0].replace(/-/g, '/');
      return date === today;
    },
    handleCloseClick(disposal) {
      this.openConfirmDialog();
      this.dialogContent=`${disposal.name}<br>廃棄登録を削除します<br>よろしいですか？`;
      this.itemDelete = disposal;
    },
    openConfirmDialog() {
      this.isConfirmDialogOpen = true;
    },
    async handleConfirm() {
      this.removeCache();
      const apiUrl = '/api/delete_disposal.php';
      const storeCode = this.$store.state.tenpoCd;
      const payload = {
        api_token: this.$store.state.api_token,
        disposal: this.itemDelete,
        store_code: storeCode
      };
          this.disposalsUpdate = this.disposalsUpdate.map(disposal => {
            if (disposal.code === this.itemDelete.code) {
              disposal.updated_at = '';
            }
            return disposal;
        });
        

      await axios.post(apiUrl, payload).then(() => {
        this.openDialog();
        this.filterSearch();
      }).catch((error) => {
        if (error.response && error.response.status === 403) {
          this.$router.push({ name: 'Login' });
        }
      });
      this.dialog = false;
      this.isConfirmDialogOpen = false;
    },
    handleCancelConfirm() {
      this.isConfirmDialogOpen = false;
    },
    clearInput(disposal) {
      this.openConfirmDialog();
      disposal.disposal_quantity = '';
    },
    setFocus(disposal, isFocused) {
      this.$set(disposal, 'isFocused', isFocused);
    },
    handleBeforeUnload(event) {
      event.preventDefault();
      event.returnValue = 'Are you sure you want to leave?';
      localStorage.setItem('reloadStatus', 'true');
    },
    removeCache() {
      this.resetTable();
      localStorage.removeItem('reloadStatus');
      // Thực hiện hành động khi người dùng đồng ý load lại trang
      console.log('User agreed to reload the page');
      // reset data
      this.$store.dispatch("storeDataUpdate", []);
      this.$store.dispatch("storeDataInsert", []);
      this.$store.dispatch("storeChangeItemUpdate", true);
      this.filterSearch();
      this.disposalsInsert = [];
    },
    checkReloadStatus() {
      this.$store.dispatch("storeFilterStatusRegister", false);
      if (localStorage.getItem('reloadStatus') === 'true') {
        this.removeCache();
      }
    },
    handleSearchClick() {
      this.$store.dispatch("storeChangeItemUpdate", false);
      this.$store.dispatch("storeDataUpdate", []);
      this.filterSearch();
      this.$store.dispatch('storeFilterStatusUpdate', true);
    },
    handleSearchRegister() {
      this.$store.dispatch("storeChangeItemInsert", false);
      this.$store.dispatch("storeDataInsert", []);
      this.filterSearchRegister();
      this.$store.dispatch('storeFilterStatusRegister', true);
    },
    handleChangeUnit(event, disposal) {
      disposal.disposal_unit_code = event.target.value;
      this.$store.dispatch("storeDataUpdate", this.disposalsUpdate);
      this.$store.dispatch("storeChangeItemUpdate", true);
    },
    handleChangeReason(event, disposal) {
      disposal.disposal_reason_code = event.target.value;
      this.$store.dispatch("storeDataUpdate", this.disposalsUpdate);
      this.$store.dispatch("storeChangeItemUpdate", true);
    },
    handleChangeUnit2(event, disposal) {
      disposal.disposal_unit_code = event.target.value;
      this.$store.dispatch("storeDataInsert", this.disposalsInsert);
      this.$store.dispatch("storeChangeItemInsert", true);
    },
    handleChangeReason2(event, disposal) {
      disposal.disposal_reason_code = event.target.value;
      this.$store.dispatch("storeDataInsert", this.disposalsInsert);
      this.$store.dispatch("storeChangeItemInsert", true);
    },
    customProductFilter(option, search) {
      if (!search) return false;

      const fullWidthSearch = normalizeToKatakana(search.toLowerCase());
      const fullWidthOption = normalizeToKatakana(option.toLowerCase());

      return fullWidthOption.includes(fullWidthSearch);
    },
    handleChange(event, disposal) {
      let amount = 0;
      if (disposal.disposal_unit_code == disposal.unit_code) {
        amount = parseFloat(disposal.disposal_quantity) * parseFloat(disposal.standard_price)
      } else if (disposal.disposal_unit_code == disposal.unit_code1) {
        amount = parseFloat(disposal.disposal_quantity) * parseFloat(disposal.standard_price) / parseFloat(disposal.conversion_rate1)
      } else if (disposal.disposal_unit_code == disposal.unit_code2) {
        amount = parseFloat(disposal.disposal_quantity) * parseFloat(disposal.standard_price) / parseFloat(disposal.conversion_rate2)
      }
      if ((amount > 5000)) {
        this.dialogError = true;
      }
    },
    resetInput(disposal) {
      disposal.disposal_quantity = '';
    },
    storePreviousQuantity(disposal) {
      disposal.previous_quantity = disposal.disposal_quantity;
    },
    removeLeadingZeros: debounce(function (disposal, action) {
      if (disposal.disposal_quantity !== null) {
        const quantityString = disposal.disposal_quantity.toString();
        if (quantityString.length > 5) {
          this.dialogErrorMaxLength = true;
        } else {
          this.dialogErrorMaxLength = false;
        }
        disposal.disposal_quantity = disposal.disposal_quantity.toString().slice(0, 5);
        disposal.disposal_quantity = parseFloat(disposal.disposal_quantity).toFixed(2);
        if (parseFloat(disposal.disposal_quantity) === 0) {
          this.dialogErrorItemZero = true;
          disposal.disposal_quantity = parseFloat(disposal.previous_quantity).toFixed(2);
        }

        let amount = 0;
        if (disposal.disposal_unit_code == disposal.unit_code) {
          amount = parseFloat(disposal.disposal_quantity) * parseFloat(disposal.standard_price)
        } else if (disposal.disposal_unit_code == disposal.unit_code1) {
          amount = parseFloat(disposal.disposal_quantity) * parseFloat(disposal.standard_price) / parseFloat(disposal.conversion_rate1)
        } else if (disposal.disposal_unit_code == disposal.unit_code2) {
          amount = parseFloat(disposal.disposal_quantity) * parseFloat(disposal.standard_price) / parseFloat(disposal.conversion_rate2)
        }
        if ((amount > 5000 && parseFloat(disposal.previous_quantity) === 0)) {
          this.dialogError = true;
        }
      } else {
        disposal.disposal_quantity = parseFloat(0).toFixed(2);
      }
      if (action === 'update') {
        this.disposalsUpdate.forEach(disp => {
          if (disp.code === disposal.code) {
            disp.disposal_quantity = parseFloat(disposal.disposal_quantity).toFixed(2);
          }
        });
        this.$store.dispatch("storeDataUpdate", this.disposalsUpdate);
        this.$store.dispatch("storeChangeItemUpdate", true);
      } else {
        this.disposalsInsert.forEach(disp => {
          if (disp.code === disposal.code) {
            disp.disposal_quantity = parseFloat(disposal.disposal_quantity).toFixed(2);
          }
        });
        this.$store.dispatch("storeDataInsert", this.disposalsInsert);
        this.$store.dispatch("storeChangeItemInsert", true);
      }
    }, 1000),
    resetTable() {
      this.disposals = [];
      this.selectedItem = null;
      this.selectedItem2 = null;
      this.selectedType = { "label": "全て", "value": -1 };
      this.selectedType2 = { "label": "全て", "value": -1 };
      this.disposalsUpdate = [];
      this.disposalsInsert = [];
    },
    handleChangeTypeItem() {
      this.$store.dispatch("storeFilterStatusUpdate", true);
    },
    handleChangeTypeItem2() {
      this.$store.dispatch("storeFilterStatusRegister", true);
    },
    openDialog() {
      this.dialog = true;
    },
    handleDialogChange(newVal) {
      this.dialog = newVal;
    },
    handleDialogChangeError(newVal) {
      this.dialogError = newVal;
    },
    handleDialogChangeErrorSubmit(newVal) {
      this.dialogErrorSubmitInsert = newVal;
    },
    handleDialogChangeErrorReason(newVal) {
      this.dialogErrorReason = newVal;
    },
    handleDialogChangeErrorAmount(newVal) {
      this.dialogErrorAmount = newVal;
    },
    handleDialogErrorMaxLength(newVal) {
      this.dialogErrorMaxLength = newVal;
    },
    handleDialogErrorItemZero(newVal) {
      this.dialogErrorItemZero = newVal;
    },
    async handleRegister() {
      if (this.checkAllDisposalQuantitiesZero(this.disposalsUpdate)) {
        this.dialogErrorAmount = true;
        return;
      }

      const apiUrl = '/api/register_disposal.php';
      const storeCode = this.$store.state.tenpoCd;
      const filteredDisposals = this.disposalsUpdate.filter(disposal => disposal.disposal_quantity > 0 && disposal.disposal_reason_code !== null);
      // Update the updated_at field to the current date
      const currentDate = new Date().toISOString().split('T')[0].replace(/-/g, '/');
      filteredDisposals.forEach(disposal => {
        disposal.updated_at = currentDate;
      });

      const payload = {
        api_token: this.$store.state.api_token,
        disposals: filteredDisposals,
        store_code: storeCode
      };
      await axios.post(apiUrl, payload).then(() => {
        this.openDialog();
        this.filterSearch();
        // Update the disposalsUpdate array with the new updated_at values
        this.disposalsUpdate = this.disposalsUpdate.map(disposal => {
          const updatedDisposal = filteredDisposals.find(fd => fd.code === disposal.code);
          return updatedDisposal ? { ...disposal, updated_at: updatedDisposal.updated_at } : disposal;
        });
        this.$store.dispatch("storeDataUpdate", this.disposalsUpdate);
        this.$store.dispatch("storeChangeItemUpdate", false);
      }).catch((error) => {
        if (error.response && error.response.status === 403) {
          this.$router.push({ name: 'Login' });
        }
      });
    },
    async handleInsert() {
      if (this.hasDuplicateDisposals()) {
        this.dialogErrorSubmitInsert = true;
        return;
      }

      if (this.checkDisposalReasonCode()) {
        this.dialogErrorReason = true;
        return;
      }
      if (this.checkAllDisposalQuantitiesZero(this.disposalsInsert)) {
        this.dialogErrorAmount = true;
        return;
      }

      const apiUrl = '/api/register_disposal.php';
      const storeCode = this.$store.state.tenpoCd;
      const filteredDisposals = this.disposalsInsert.filter(disposal => disposal.disposal_quantity > 0 && disposal.disposal_reason_code !== null);
      const payload = {
        api_token: this.$store.state.api_token,
        disposals: filteredDisposals,
        store_code: storeCode
      };
      await axios.post(apiUrl, payload).then(() => {
        this.resetTable();
        this.filterSearch();
        this.openDialog();
      }).catch((error) => {
        if (error.response && error.response.status === 403) {
          this.$router.push({ name: 'Login' });
        }
      });
    },
    hasDuplicateDisposals() {
      return this.disposalsInsert.some(insertItem =>
        this.disposals.some(disposal =>
          disposal.disposal_item_code === insertItem.code &&
          disposal.disposal_unit_code === insertItem.disposal_unit_code &&
          disposal.disposal_reason_code === insertItem.disposal_reason_code
        )
      );
    },
    checkDisposalReasonCode() {
      return this.disposalsInsert.every(disposal => disposal.disposal_reason_code === null);
    },
    checkAllDisposalQuantitiesZero(data) {
      return data.every(disposal => parseFloat(disposal.disposal_quantity) === 0 || disposal.disposal_quantity === '');
    },
    async getTypes() {
      const authToken = this.$store.state.api_token;
      const url = `/api/get_the_disposal_type.php?api_token=${authToken}`;
      axios.get(url).then((response) => {
        this.types = response.data.data.map((item) => ({
          label: item.condition_name,
          value: item.condition_type,
        }));
      }).catch((error) => {
        if (error.response && error.response.status === 403) {
          this.$router.push({ name: 'Login' });
        }
      });
    },
    async getItems() {
      this.isLoading1 = true;
      const authToken = this.$store.state.api_token;
      const storeCode = this.$store.state.tenpoCd;
      let url = `/api/get_disposal_item_list_for_normal_registration.php?api_token=${authToken}&store_code=${storeCode}`;
      if (this.selectedType !== null) {
        url += `&disposal_type=${this.selectedType.value}`;
      }
      await new Promise(resolve => setTimeout(resolve, 2000));
      await axios.get(url).then((response) => {
        this.items = response.data.data.map(
          (item) => `${item.disposal_item_code} ${item.disposal_item_name}`
        );
        this.isLoading1 = false;
      }).catch((error) => {
        if (error.response && error.response.status === 403) {
          this.$router.push({ name: 'Login' });
        }
      });
    },

    async filterSearch() {
      if (this.$store.state.changeItemUpdate && this.$store.state.dataUpdate.length > 0) {
        this.disposalsUpdate = this.$store.state.dataUpdate;
        return false;
      }
      else {
        this.isLoading1 = true;
        let disposalCode = null;
        if (!this.selectedType) {
          this.selectedType = null;
        }

        if (this.selectedItem) {
          this.disposalItemCode = this.selectedItem.split(" ")[0];
        } else {
          this.disposalItemCode = null;
        }

        if (!this.selectedType2) {
          this.selectedType2 = null;
        }
        if (this.selectedItem2) {
          disposalCode = this.selectedItem2.split(" ")[0];
        }

        const authToken = this.$store.state.api_token;
        const storeCode = this.$store.state.tenpoCd;
        let url = `/api/get_disposal_item_list_for_normal_registration.php?api_token=${authToken}&store_code=${storeCode}`;
        if (this.selectedType !== null) {
          url += `&disposal_type=${this.selectedType.value}`;
        }
        if (this.disposalItemCode !== null) {
          url += `&disposal_item_code=${this.disposalItemCode}`;
        }
        this.$store.dispatch("filterData", {
          code1: this.selectedItem,
          type1: { "label": this.selectedType.label, "value": this.selectedType.value },
          code2: this.selectedItem2,
          type2: { "label": this.selectedType2.label, "value": this.selectedType2.value },
        });

        // Update URL to browser
        let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?api_token=${authToken}&store_code=${storeCode}`;
        newUrl += `&type1=${this.selectedType.value}`;
        newUrl += `&code1=${this.disposalItemCode}`;
        newUrl += `&type2=${this.selectedType2.value}`;
        newUrl += `&code2=${disposalCode}`;
        window.history.pushState({ path: newUrl }, '', newUrl);

        await axios.get(url).then((response) => {
          this.disposals = response.data.data.map((item) => {
            return {
              ...item,
              disposal_amount: parseFloat(item.disposal_amount).toFixed(2),
            };
          });
          const defaultReason = this.reasons[0].value;
          this.disposalsUpdate = response.data.data.map((item) => {
            return {
              disposal_date: item.disposal_date,
              store_code: item.store_code,
              disposal_type: item.disposal_type,
              name: item.disposal_item_name,
              code: item.disposal_item_code,
              disposal_quantity: parseFloat(item.disposal_quantity).toFixed(2),
              previous_quantity: parseFloat(item.disposal_quantity).toFixed(2),
              disposal_unit_code: item.disposal_unit_code ?? item.unit_code,
              disposal_reason_code: item.disposal_reason_code ?? defaultReason,
              remarks: item.remarks,
              registered_company: item.registered_company,
              registered_person: item.registered_person,
              updated_company: this.$store.state.kaisyacd,
              updated_person: this.$store.state.shaincd,
              unit_name: item.unit_name,
              unit_code: item.unit_code,
              unit_name1: item.unit_name1,
              unit_code1: item.unit_code1,
              unit_code2: item.unit_code2,
              unit_name2: item.unit_name2,
              disposal_amount: item.disposal_amount,
              standard_price: item.standard_price,
              conversion_rate1: item.conversion_rate1,
              conversion_rate2: item.conversion_rate2,
              updated_at: item.updated_at,
            };
          });
          this.isLoading1 = false;
          this.$store.dispatch("storeDataUpdate", this.disposalsUpdate);

        }).catch((error) => {
          if (error.response && error.response.status === 403) {
            this.$router.push({ name: 'Login' });
          }
        });
      }
    },
    async getItems2() {
      this.isLoading2 = true;
      const authToken = this.$store.state.api_token;
      const storeCode = this.$store.state.tenpoCd;
      let url = `/api/get_list_product_purchased.php?api_token=${authToken}&store_code=${storeCode}`;
      if (this.selectedType2 !== null) {
        url += `&type=${this.selectedType2.value}`;
      }
      await new Promise(resolve => setTimeout(resolve, 2000));
      await axios.get(url).then((response) => {
        this.items2 = response.data.data.map(
          (item) => `${item.ProductCode} ${item.ProductName}`
        );
        this.isLoading2 = false;
      }).catch((error) => {
        if (error.response && error.response.status === 403) {
          this.$router.push({ name: 'Login' });
        }
      });
    },
    async filterSearchRegister() {
      this.isLoading2 = true;
      let disposalCode = null;

      if (!this.selectedType) {
        this.selectedType = null;
      }

      if (this.selectedItem) {
        this.disposalItemCode = this.selectedItem.split(" ")[0];
      } else {
        this.disposalItemCode = null;
      }

      if (!this.selectedType2) {
        this.selectedType2 = null;
      }

      if (this.selectedItem2) {
        disposalCode = this.selectedItem2.split(" ")[0];
      }

      const authToken = this.$store.state.api_token;
      const storeCode = this.$store.state.tenpoCd;
      let url = `/api/get_list_product_purchased.php?api_token=${authToken}&store_code=${storeCode}`;
      if (this.selectedType2 !== null) {
        url += `&type=${this.selectedType2.value}`;
      }
      if (disposalCode !== null) {
        url += `&code=${disposalCode}`;
      }

      this.$store.dispatch("filterData", {
        code1: this.selectedItem,
        type1: { "label": this.selectedType.label, "value": this.selectedType.value },
        code2: this.selectedItem2,
        type2: { "label": this.selectedType2.label, "value": this.selectedType2.value }
      });

      this.$store.dispatch("storeFilterStatusRegister", true);

      let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?api_token=${authToken}&store_code=${storeCode}`;
      newUrl += `&type1=${this.selectedType.value}`;
      newUrl += `&code1=${this.disposalItemCode}`;
      newUrl += `&type2=${this.selectedType2.value}`;
      newUrl += `&code2=${disposalCode}`;
      window.history.pushState({ path: newUrl }, '', newUrl);

      await axios.get(url).then((response) => {
        this.disposalsInsert = response.data.data.map((item) => {
          return {
            disposal_date: item.DisposalDate,
            store_code: storeCode,
            disposal_type: item.Type,
            name: item.ProductName,
            code: item.ProductCode,
            disposal_quantity: parseFloat(0).toFixed(2),
            previous_quantity: parseFloat(0).toFixed(2),
            disposal_unit_code: item.UnitCode, // default unit
            disposal_reason_code: null, // default reason
            remarks: item.Remarks,
            registered_company: this.$store.state.kaisyacd,
            registered_person: this.$store.state.shaincd,
            updated_company: this.$store.state.kaisyacd,
            updated_person: this.$store.state.shaincd,
            unit_name: item.UnitName,
            unit_code: item.UnitCode,
            unit_name1: item.AuxUnitName1,
            unit_code1: item.AuxUnitCode1,
            unit_name2: item.AuxUnitName2,
            unit_code2: item.AuxUnitCode2,
            disposal_amount: item.disposal_amount,
            standard_price: item.StandardPrice,
            conversion_rate1: item.AuxUnitConversionRate1,
            conversion_rate2: item.AuxUnitConversionRate2,
          };
        });

        if (this.$store.state.changeItemInsert) {
          this.disposalsInsert = this.$store.state.dataInsert;
        } else {
          this.$store.dispatch("storeDataInsert", this.disposalsInsert);
        }

      }).catch((error) => {
        if (error.response && error.response.status === 403) {
          this.$router.push({ name: 'Login' });
        }
      });

      this.isLoading2 = false;
    },
    getUnits(disposal) {
      return [
        { name: disposal.unit_name, value: disposal.unit_code },
        { name: disposal.unit_name1, value: disposal.unit_code1 },
        { name: disposal.unit_name2, value: disposal.unit_code2 },
      ];
    },
    async getReasons() {
      const authToken = this.$store.state.api_token;
      let url = `/api/get_the_disposal_reason.php?api_token=${authToken}`;
      await axios.get(url).then((response) => {
        this.reasons = response.data.data.map((item) => ({
          name: item.reason_content,
          value: item.reason_code,
        }));
      }).catch((error) => {
        if (error.response && error.response.status === 403) {
          this.$router.push({ name: 'Login' });
        }
      });
    },
  },
  watch: {
    selectedType: {
      async handler(newVal) {
        const storeCode = this.$store.state.tenpoCd;
        const authToken = this.$store.state.api_token;
        let url = `/api/get_disposal_item_list_for_normal_registration.php?api_token=${authToken}&store_code=${storeCode}`;
        if (newVal !== null) {
          url += `&disposal_type=${newVal.value}`;
        }
        await axios.get(url).then((response) => {
          this.items = response.data.data.map(
            (item) => `${item.disposal_item_code} ${item.disposal_item_name}`
          );
        }).catch((error) => {
          if (error.response && error.response.status === 403) {
            this.$router.push({ name: 'Login' });
          }
        });

      }
    },
    selectedType2: {
      async handler(newVal) {
        this.selectedItem2 = null;
        const storeCode = this.$store.state.tenpoCd;
        const authToken = this.$store.state.api_token;
        let url = `/api/get_list_product_purchased.php?api_token=${authToken}&store_code=${storeCode}`;
        if (newVal !== null) {
          url += `&type=${newVal.value}`;
        }
        await axios.get(url).then((response) => {
          this.items2 = response.data.data.map(
            (item) => `${item.ProductCode} ${item.ProductName}`
          );
        }).catch((error) => {
          if (error.response && error.response.status === 403) {
            this.$router.push({ name: 'Login' });
          }
        });
      }
    }
  },
};
</script>

<style scoped>
select {
  -webkit-appearance: auto;
  appearance: auto;
}

.styled-table-wrapper {
  max-height: 390px;
  overflow-y: auto;
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.styled-table th,
.styled-table td {
  border: 1px solid #ddd;
  padding: 8px 4px;
}

.styled-table th {
  background-color: #DAE8FC;
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 1;
}

.styled-table td {
  position: relative;
}

.styled-table .full-size-input {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  text-align: center;
}

.styled-table .full-size-div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 2px;
}

.close-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: red;
  z-index: 2;
}

.full-size-div.focus .close-icon {
  display: block;
}

.close-icon:hover {
  color: #920707;
}
@media only screen and (min-width: 360px) {
  .styled-table {
    font-size: 14px;
  }

  .close-icon {
    position: absolute;
    top: 20%;
    right: 0px;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 28px;
    cursor: pointer;
    color: red;
    z-index: 2;
  }
}

@media only screen and (min-width: 430px) {
  .styled-table {
    font-size: 18px;
  }

  .close-icon {
    position: absolute;
    top: 26%;
    right: 0px;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 33px;
    cursor: pointer;
    color: red;
    z-index: 2;
  }
}

/** responsive tablet */
@media only screen and (min-width: 960px) {
  .styled-table {
    font-size: 20px;
  }

  .v-btn.v-size--large {
    min-width: 120px !important;
  }

  .form-reg-prod {
    height: calc(100vh - 33px);
  }

  .form-reg-prod-container {
    height: 100%;
    display: flex;
  }

  .form-reg-prod-col {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .content-styled-table {
    height: calc(100% - 266px);
  }

  .content-styled-table .col {
    height: 100%;
  }

  .styled-table-wrapper {
    max-height: 100%;
    overflow-y: auto;
  }

  /* Add this CSS to your component's style section or a global stylesheet */
  .no-spinner::-webkit-outer-spin-button,
  .no-spinner::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .no-spinner {
    -moz-appearance: textfield;
    /* Firefox */
  }
}
</style>
